<template>
  <div class="home">
    <div class="bgc">
      <div class="center">
        <div class="top">
          <div class="logo"><img src="../assets/images/latast_pc/homeLogo.png" alt=""></div>
          <div class="day">{{time}}</div>
          <div class="day1">{{year}} {{day}}</div>
        </div>
        <div class="bottom">
          <div :class="'list'+index" v-for="(item,index) in list" :key="index" @click="btn(index, item.path)" :style="item.name == '交易中心' ? 'color:#ccc':''">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '../config/config-1.js'
export default {
  data () {
    return {
      time: '',
      year: '',
      day: '',
      list: [
        { path: Config.masterGoBackTest + 'carbonReduction', name: '减碳行为' },
        { path: Config.masterGoBackTest + 'rightsAndInterests', name: '权益体系' },
        { path: Config.masterGoBackTest + 'tradingSystem', name: '交易体系' },
        { path: Config.masterGoBackTest + 'greenFund', name: '绿色基金' },
        { path: '', name: '交易中心' },
      ]
    }
  },
  mounted () {
    let _this = this
    setInterval(function () {
      _this.getDate()
    }, 1000)
  },
  methods: {
    btn (idx, path) {
      let data = this.list
      if (idx == 0) {
        this.list.unshift(...data.slice(-2))
        this.list.splice(-2)
      } else if (idx == 1) {
        this.list.unshift(...data.slice(-1))
        this.list.splice(-1)
      } else if (idx == 2) {
      } else if (idx == 3) {
        this.list.push(...data.slice(0, 1))
        this.list.splice(0, 1)
      } else if (idx == 4) {
        this.list.push(...data.slice(0, 2))
        this.list.splice(0, 2)
      }
      setTimeout(()=> {
        this.$router.push(path)
      }, 800)
    },
    getDate () {
      let date = new Date();
      let Year = date.getFullYear()
      let Mon = date.getMonth() + 1
      let D = date.getDate()

      let h = date.getHours()
      let m = date.getMinutes()
      let s = date.getSeconds()

      this.time = this.getNew(h) + ':' + this.getNew(m) + ':' + this.getNew(s)
      this.year = Year + '-' + this.getNew(Mon) + '-' + this.getNew(D)
      this.day = this.getDay(date.getDay())
    },
    getNew (time) {
      return time < 10 ? '0' + time : time
    },
    getDay (val) {
      if (val == 0) {
        return '星期日'
      } else if (val == 1) {
        return '星期一'
      } else if (val == 2) {
        return '星期二'
      } else if (val == 3) {
        return '星期三'
      } else if (val == 4) {
        return '星期四'
      } else if (val == 5) {
        return '星期五'
      } else if (val == 6) {
        return '星期六'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  padding-top: .5rem;
  .bgc {
    width: 90%;
    // background-image: linear-gradient(0deg, rgba(114,231,248,0) 50%, rgba(97, 187, 255, .4) 100%);
    background-image: linear-gradient(0deg, rgba(114,231,248,0) 50%, rgba(0,113,198, .28) 100%);
    margin: 0 5%;
  }
  .center {
    width: 80%;
    height: 85vh;
    margin: 0 10%;
    background-image: url('../assets/images/latast_pc/home_pc_center.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .top {
      width: 100%;
      height: 40vh;
      color: #fff;
      .logo {
        width: 30%;
        margin: 0 auto;
        padding-top: 3vw;
        box-sizing: border-box;
        margin-bottom: .3rem;
        img {
          width: 100%;
        }
      }
      .day {
        font-family: YouSheBiaoTiHei;
        font-weight: 600;
        font-size: 1rem;
        color: #FFFFFF;
        text-align: center;
        text-shadow: 0 0 26px #1492FF;
        line-height: 3vw;
      }
      .day1 {
        font-family: YouSheBiaoTiHei;
        font-weight: 600;
        font-size: .4rem;
        color: #FFFFFF;
        text-align: center;
        text-shadow: 0 0 26px #1492FF;
        line-height: 3vw;
      }
    }
    .bottom {
      width: 58%;
      height: 18vh;
      color: #fff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      text-align: center;
      position: absolute;
      left: 50%;
      bottom: 1%;
      transform: translate(-50%, -50%);
      // margin-left: 5.3rem;
      // margin-top: 2.8rem;

      .list0, .list4 {
        width: 8vh;
        height: 8vh;
        line-height: 8vh;
        font-size: .25rem;
        background-image: url('../assets/images/latast_pc/btn_bgc_3.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .list1, .list3 {
        width: 10vh;
        height: 10vh;
        line-height: 10vh;
        font-size: .3rem;
        margin-top: .55rem;
        font-weight: 500;
        background-image: url('../assets/images/latast_pc/btn_bgc_2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .list2 {
        width: 15vh;
        height: 15vh;
        line-height: 15vh;
        font-size: .37rem;
        margin-top: .3rem;
        font-weight: 600;
        background-image: url('../assets/images/latast_pc/btn_bgc_1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue